import React from 'react';

import { Checkbox, FormControlLabel, InputLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import AdminSettingsContainer from '../AdminSettingsContainer';
import { StyledFormGroup, StyledFormGroupContainer } from '../styles';

const ZoomAdminSettings = () => {
    const { t } = useTranslation('admin_settings');

    const { adminSettings, setAdminSettings, setSavingDisabled } = useContainer(AdminSettingsContainer);
    const { featureSettings } = adminSettings;

    const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const sanitizedInput = event.target.value.replace(/[^0-9,]/g, '');
        event.target.value = sanitizedInput;

        const accountNumbers = sanitizedInput
            .split(',')
            .map((i) => i.trim())
            .filter((i) => i.length > 0)
            .map((i) => parseInt(i, 10));

        featureSettings.options.zoomAccountNumbers = [...accountNumbers];
        setAdminSettings({ ...adminSettings });
    };

    const handleUpdateOptionsCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        featureSettings.options[event.target.name] = event.target.checked;
        setAdminSettings({ ...adminSettings });
    };

    const getDefaultValue = () => {
        const accountNumbers = featureSettings.options.zoomAccountNumbers;
        return accountNumbers.length > 0 ? accountNumbers.join(',') : '';
    };

    return (
        <StyledFormGroupContainer>
            <StyledFormGroup>
                <InputLabel htmlFor="zoomAccountNumbers">{t('auth.zoom-account-id-label')}</InputLabel>
                <TextField
                    defaultValue={getDefaultValue()}
                    onChange={handleTextFieldChange}
                    id="zoomAccountNumbers"
                    helperText={t('auth.zoom-account-id-helper')}
                    size="small"
                />
            </StyledFormGroup>

            <FormControlLabel
                control={
                    <Checkbox
                        checked={featureSettings.options.autoProvisionNewUsersZoom}
                        onChange={handleUpdateOptionsCheckboxChange}
                        id="autoProvisionNewUsersZoom"
                        name="autoProvisionNewUsersZoom"
                    />
                }
                label={t('auth.allow-account-provisioning')}
            />
        </StyledFormGroupContainer>
    );
};

export default ZoomAdminSettings;
